
import { useAppSelector } from '../../../../store'
import { NotificationsHistory } from '../../../NotificationsHistory'
import { NoDataPlaceHolder } from '../../../PatientFolder/behavioral/components'
import * as Sidebar from '../components/index'

export function Notifications (): JSX.Element {
    const notificationsHistory = useAppSelector((state) => state.notificationsHistory)
    const {notifications = []} = notificationsHistory || {}

  if (!notifications || notifications.length <= 0) {
    return (
      <>
        <Sidebar.Header>
          Notifications
        </Sidebar.Header>
        <Sidebar.Wrapper style={{ padding: '5px 0px 5px 0px' }}>
          <NoDataPlaceHolder
            title='No new notifications'
            className='bg-transparent'

          />
        </Sidebar.Wrapper>
      </>
    )
  }

  return (
    <>
      <Sidebar.Header>
          Notifications {notifications.length || ''}
      </Sidebar.Header>
      <Sidebar.Wrapper style={{ padding: '5px 0' }}>
        <NotificationsHistory sendMessage={() => ({})} />
      </Sidebar.Wrapper>
    </>
  )
}
